module.exports = __webpack_public_path__ + "img/conclusion4.987f3de0.svg";